import { useTranslation } from 'react-i18next';
import { Typography } from '@web-chat-core/ui-kit';
import { ModalName } from 'features/Modals';
import { useModal } from 'useCase/modal/useModal';
import { StyledButton, StyledIcon } from './view';

export const VirtualBackgroundButtonWithText = () => {
    const { t } = useTranslation();

    const { toggleModal } = useModal();

    const handleClick = () => {
        toggleModal(ModalName.VIRTUAL_BACKGROUND);
    };

    return (
        <StyledButton key="virtual-background-button" onClick={handleClick}>
            <StyledIcon icon="icAddFacePhoto" colorVariant="basic" size={24} />
            <Typography variant="body3" colorVariant="base">
                {t('videoconference_virtual_backgrounds')}
            </Typography>
        </StyledButton>
    );
};

VirtualBackgroundButtonWithText.displayName = 'VirtualBackgroundButtonWithText';
